module.exports = __webpack_public_path__ + "img/artboard-1-copia-2-100.36722585.jpg";